import React, { useReducer, useContext, useCallback } from "react"
import AreaReducer from 'leads/area/state/AreaReducer'
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';

export const AreaContext = React.createContext();

const AreaState = ({ children }) => {
	const initialState = {
		areas: [],
	}
	const [state, dispatch] = useReducer(AreaReducer, initialState);
	const { asyncServiceCall } = useContext(SessionContext);

	const setGeoLocation = useCallback(async (search) => {
		try {
			for (; ;) {
				let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_GEO_LOCATION, { q: search });
				if (res.list.length || search.split("+").length <= 1) {
					dispatch({ type: 'SET_GEO_LOCATION', payload: res.list });
					return;
				}
				search = search.split("+").slice(0, search.split("+").length - 1).join("+");
			}
		}
		catch (err) {
			console.log(err);
		}
	}, [asyncServiceCall]);

	const searchArea = useCallback(async (txtAreaName) => {
		try {
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_AREA, { txtAreaName: txtAreaName });
			dispatch({ type: 'SET_AREA_MATCH', payload: res });
		}
		catch (err) {
			console.log(err);
			dispatch({ type: 'LOADED' });
		}
	}, [asyncServiceCall]);

	//-----------------------------------------------
	const searchLane = useCallback(async ({ txtLaneName, around }) => {
		try {
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_LANE, {
				txtLaneName: txtLaneName,
				around: around,
			});
			dispatch({
				type: 'SET_LANE_MATCH', payload: {
					txtLaneName: txtLaneName,
					lanes: res,
				}
			});
		}
		catch (err) {
			console.log(err);
			dispatch({ type: 'LOADED' });
		}
	}, [asyncServiceCall]);

	return (
		<AreaContext.Provider
			value={{
				...state,
				dispatch,
				searchArea,
				searchLane,
				setGeoLocation,
			}}
		>
			{children}
		</AreaContext.Provider>
	)
}

export default AreaState
